import type { MaxOrderable } from '../../../shared/utils/stockValidation';
import { Data } from 'effect';

import { ErrorTag } from '@vs-shop/engine/data/error/index';

/**
 * Client-side order validation error - thrown before API call
 * when cart already contains maximum orderable quantity
 */
export class MaxOrderableInCartError extends Data.TaggedError(ErrorTag.MaxOrderableInCartError)<{
  productVariant: string;
  quantityInCart: number;
  maxOrderable: MaxOrderable;
  message: string;
}> {
  constructor(params: {
    productVariant: string;
    quantityInCart: number;
    maxOrderable: MaxOrderable;
    message: string;
  }) {
    // Type narrowing: Since this error is only created when isMaxOrderableExceededInCart returns true,
    // we know maxOrderable is guaranteed to be a positive number (not null or 0).
    // However, TypeScript doesn't track this guarantee, so we handle it here.
    const maxOrderableValue = params.maxOrderable ?? 0;

    super({
      ...params,
      maxOrderable: maxOrderableValue,
    });
  }
}

/**
 * The backend answered a cart read with a status other than `2xx` or `404`.
 * The cart may still exist, so the order token stays where it is.
 */
export class OrderReadFailedError extends Data.TaggedError('@app/Order/OrderReadFailedError')<{
  readonly status: number;
  readonly cause: unknown;
}> {}
